// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"wR","category":"wS","tab":"wT","selected":"wU","isRental":"wV"};